module.exports = __webpack_public_path__ + "img/sign.ba92b8fb.png";